import { useEffect, useState, useRef } from 'react';

export const SalaryBar = ({ value, maxValue, className = '' }) => {
  const [width, setWidth] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  const percentage = Math.min((value / maxValue) * 100, 100);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [isVisible]);

  useEffect(() => {
    if (isVisible) {
      // Small delay for animation effect
      const timer = setTimeout(() => {
        setWidth(percentage);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [isVisible, percentage]);

  return (
    <div ref={ref} className={`salary-bar ${className}`}>
      <div 
        className="salary-bar-fill"
        style={{ width: `${width}%` }}
      />
    </div>
  );
};

export default SalaryBar;
